import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'
export default {
  getPaymentAmount () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Payment2/amount',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getSaleAmount () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Sale/amount',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getUnPaymentAmount () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Payment/UnPaymentAmount',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  postRequestPayment () {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Payment',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(msg.updateFail)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  postRequestSaleDetailsDownload (payload = {}, fileName = 'download.csv') {
    return new Promise((resolve, reject) => {
      Axios.download(
        'Sale/detail/download',
        payload,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  },

  postRequestPaymentPdfDownload (params = {}, fileName = 'download.pdf') {
    return new Promise((resolve, reject) => {
      Axios.pdfDownload(
        'paid/pdf.pdf',
        params,
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        },
        fileName
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/saleservice.js